import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import css from './OrderBreakdown.module.css';

const LineItemDamageProtectionPlan = props => {
  const { lineItem } = props;

  if (!lineItem || !lineItem.lineTotal) {
    return null;
  }

  const amount = lineItem.lineTotal.amount / 100;
  const currency = lineItem.lineTotal.currency;

  return (
    <div className={css.lineItem}>
      <span className={css.lineItemLabel}>
        <FormattedMessage
          id="OrderBreakdown.damageProtectionPlan"
          defaultMessage="Damage Protection Plan"
        />
      </span>
      <span className={css.lineItemAmount}>
        {currency} {amount.toFixed(2)}
      </span>
    </div>
  );
};

LineItemDamageProtectionPlan.propTypes = {
  lineItem: PropTypes.object.isRequired,
};

export default LineItemDamageProtectionPlan;